export default __webpack_public_path__ + "assets/main_background.789e2c72f3a94811bbe0934f5d3bd1a0.svg";